import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import privacyStyle from "assets/jss/material-kit-pro-react/views/privacySections/privacyStyle.js";

const useStyles = makeStyles(privacyStyle);

export default function SectionPrivacy() {
  const classes = useStyles();
  return (
    <div className={classes.featuresSection}>
        {/* <h2 className={classes.title + " " + classes.textCenter}>COMING SOON</h2>
        <h4 className={classes.title + " " + classes.textCenter}>We are updating our Privacy Policy and will have it up soon</h4> */}
        <h1 className={classes.title}>Privacy Policy for Utah Swim Academy</h1>
          <p>Last updated: May 15, 2025</p>
        <h4>Utah Swim Academy is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information, including when you schedule swim lessons or join a waitlist for your child.</h4>
        <h2 className={classes.title}>Information We Collect</h2>
          <p>We collect personal information when you:</p>
          <ul>
            <li>Register for an account</li>
            <li>Purchase and/or schedule swim lessons</li>
            <li>Join a waitlist</li>
            <li>Contact us for support or information</li>
          </ul>
          <p>This may include:</p>
          <ul>
            <li>Parent or guardian name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Address</li>
            <li>Child’s name and age</li>
          </ul>
        <h2 className={classes.title}>How We Use Your Information</h2>
          <p>We use the information you provide to:</p>
          <ul>
            <li>Manage your swim lesson schedule</li>
            <li>Notify you when a spot opens up from the waitlist</li>
            <li>Communicate important updates related to your child’s lessons</li>
            <li>Respond to support requests</li>
          </ul>
        <h2 className={classes.title}>SMS Notifications</h2>
          <p>If you join a waitlist, you may receive SMS messages when a lesson time becomes available. Messages are sent in the order families join the waitlist. You’ll typically have 10 minutes to claim the spot before we notify the next family.</p>
          <ul>
            <li>Message and data rates may apply.</li>
            <li>Reply <b>STOP</b> to unsubscribe from SMS notifications.</li>
            <li>Reply <b>HELP</b> for assistance.</li>
            <li>Respond to support requests</li>
          </ul>
          <p>You may also receive SMS messages in the event of a pool closure, lesson cancellation, or other time-sensitive announcements.</p>
          <p>We do not use your phone number for marketing purposes.</p>
        <h2 className={classes.title}>Sharing Your Information</h2>
          <p>We do <b>not</b> sell your personal information. We only share it when necessary to provide our services (e.g. with our SMS service provider) or as required by law.</p>
        <h2 className={classes.title}>Your Rights and Choices</h2>
          <p>You can request to view, update, or delete your information at any time by contacting us.</p>
          <p>To request changes or ask questions about your data, email us at: <a href="mailto:info@utahswimacademy.com">info@utahswimacademy.com</a></p>
        <h2 className={classes.title}>Policy Updates</h2>
          <p>We may update this Privacy Policy from time to time. When we do, we’ll update the “Last updated” date at the top of this page.</p>
    </div>
  );
}
